export const MAIN_THEME_COLOR = '#21C17A';
export const WHITE = '#FFFFFF';
export const BLACK = '#000000';
export const GREY = '#A6A5A5';
